import { render, staticRenderFns } from "./AccountRegist.vue?vue&type=template&id=c84ca852&scoped=true&"
import script from "./AccountRegist.vue?vue&type=script&lang=js&"
export * from "./AccountRegist.vue?vue&type=script&lang=js&"
import style0 from "./AccountRegist.vue?vue&type=style&index=0&id=c84ca852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ca852",
  null
  
)

export default component.exports